import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ListColumnTitle } from '@app-models/list-column-title';
import { filter, map, property, join } from 'lodash';

@Component({
  selector: 'app-list-row-wrapper',
  templateUrl: './list-row-wrapper.component.html',
  styleUrls: ['./list-row-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ListRowWrapperComponent implements OnInit, AfterViewInit {
  @Input() columns: ListColumnTitle[];

  isXSmall = false;
  isSmall = false;
  isMedium = false;
  isLarge = false;

  isHover = false;
  cssClass: any;

  @ViewChild('content', { static: false }) myDivElementRef: ElementRef;

  constructor(public breakpointObserver: BreakpointObserver) {}

  ngAfterViewInit(): void {
    this.calculateColumnsContainer();
    this.visibilityColumnsController();
  }

  visibilityColumnsController() {
    if (this.isLarge || this.isMedium) {
      this.columns.map((column, index) => {
        if (column.columnSizeDesktop && column.showIsDesktop) {
          this.myDivElementRef.nativeElement.childNodes[index].style.display =
            'grid';
          this.myDivElementRef.nativeElement.childNodes[
            index
          ].style.justifyContent = column.align;
        } else {
          if (this.myDivElementRef.nativeElement.childNodes[index].style) {
            this.myDivElementRef.nativeElement.childNodes[index].style.display =
              'none';
          }
        }
      });
    }

    if (this.isSmall) {
      this.columns.map((column, index) => {
        if (
          column.columnSizeTablet &&
          column.showIsTablet &&
          this.myDivElementRef.nativeElement.childNodes[index].style
        ) {
          this.myDivElementRef.nativeElement.childNodes[index].style.display =
            'grid';
          this.myDivElementRef.nativeElement.childNodes[
            index
          ].style.justifyContent = column.align;
        } else {
          if (this.myDivElementRef.nativeElement.childNodes[index].style) {
            this.myDivElementRef.nativeElement.childNodes[index].style.display =
              'none';
          }
        }
      });
    }

    if (this.isXSmall) {
      this.columns.map((column, index) => {
        if (
          column.columnSizeMobile &&
          column.showIsMobile &&
          this.myDivElementRef.nativeElement.childNodes[index].style
        ) {
          this.myDivElementRef.nativeElement.childNodes[index].style.display =
            'grid';
          this.myDivElementRef.nativeElement.childNodes[
            index
          ].style.justifyContent = column.align;
        } else {
          if (this.myDivElementRef.nativeElement.childNodes[index].style) {
            this.myDivElementRef.nativeElement.childNodes[index].style.display =
              'none';
          }
        }
      });
    }
  }

  ngOnInit(): void {
    this.breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .subscribe((result) => {
        if (result.breakpoints[Breakpoints.XSmall]) {
          this.isXSmall = true;
          this.isSmall = false;
          this.isMedium = false;
          this.isLarge = false;
        }
        if (result.breakpoints[Breakpoints.Small]) {
          this.isXSmall = false;
          this.isSmall = true;
          this.isMedium = false;
          this.isLarge = false;
        }
        if (result.breakpoints[Breakpoints.Medium]) {
          this.isXSmall = false;
          this.isSmall = false;
          this.isMedium = true;
          this.isLarge = false;
        }
        if (result.breakpoints[Breakpoints.Large]) {
          this.isXSmall = false;
          this.isSmall = false;
          this.isMedium = false;
          this.isLarge = true;
        }
        if (result.breakpoints[Breakpoints.XLarge]) {
          this.isXSmall = false;
          this.isSmall = false;
          this.isMedium = false;
          this.isLarge = true;
        }
      });
  }

  calculateColumnsContainer() {
    this.isHover = false;
    let columns = [];
    if (this.isMedium || this.isLarge) {
      const filteredColumns = filter(
        this.columns,
        (item) => item.showIsDesktop
      );
      columns = map(filteredColumns, property('columnSizeDesktop'));
    }
    if (this.isSmall) {
      const filteredColumns = filter(this.columns, (item) => item.showIsTablet);
      columns = map(filteredColumns, property('columnSizeTablet'));
    }
    if (this.isXSmall) {
      const filteredColumns = filter(this.columns, (item) => item.showIsMobile);
      columns = map(filteredColumns, property('columnSizeMobile'));
    }
    const gridColumnTemplateArray = map(columns, (item) => {
      return item + 'fr';
    });
    const gridColumnTemplate = join(gridColumnTemplateArray, ' ');
    const cssClass = {
      display: 'grid',
      'grid-template-columns': gridColumnTemplate,
    };
    this.cssClass = cssClass;
    this.visibilityColumnsController();
  }

  calculateHoverColumnsContainer() {
    let columns = [];
    let cssClass: any;
    this.isHover = true;
    if (this.isMedium || this.isLarge) {
      const columnsToHide = filter(
        this.columns,
        (item) => item.showIsDesktop && item.isHideOnHover
      );
      const filteredColumnsToHide = map(
        columnsToHide,
        property('columnSizeDesktop')
      );

      const sumColumns = filteredColumnsToHide.reduce(
        (a: number, b: number) => a + b,
        0
      );

      const filteredColumns = filter(
        this.columns,
        (item) => item.showIsDesktop && !item.isHideOnHover
      );
      columns = map(filteredColumns, property('columnSizeDesktop'));

      columns.push(sumColumns);

      const gridColumnTemplateArray = map(columns, (item) => {
        return item + 'fr';
      });

      const gridColumnTemplate = join(gridColumnTemplateArray, ' ');
      cssClass = {
        display: 'grid',
        'grid-template-columns': gridColumnTemplate,
      };
      this.cssClass = cssClass;

      this.columns.map((column, index) => {
        if (column.isHideOnHover) {
          this.myDivElementRef.nativeElement.childNodes[index].style.display =
            'none';
        } else {
          this.myDivElementRef.nativeElement.childNodes[index].style.display =
            'grid';
          this.myDivElementRef.nativeElement.childNodes[
            index
          ].style.justifyContent = column.align;
        }
      });
    } else {
      this.calculateColumnsContainer();
    }
  }
}
